// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 28-it-dashboard-ui.md
import * as React from 'react';

import { cn } from '@/lib/utils';
import type { AuthCategory } from '@greenlight/shared';

const CATEGORY_LABELS: Record<AuthCategory, string> = {
  'service-identity': 'Service-identity',
  'user-delegated': 'User passthrough',
  'connected-database': 'Connected database',
  'provisioned-resource': 'Provisioned resource',
};

export function authCategoryLabel(category: AuthCategory): string {
  return CATEGORY_LABELS[category];
}

export interface AuthCategoryChipProps {
  category: AuthCategory;
  className?: string;
}

/**
 * Neutral filled chip displaying the integration's credential-backed auth category.
 * Always renders in neutral muted tones — green/amber/red are reserved for StatusBadge.
 */
export function AuthCategoryChip({
  category,
  className,
}: AuthCategoryChipProps): React.JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-gl bg-muted/60 px-2 py-0.5 font-mono text-[11px] text-foreground',
        className,
      )}
    >
      {CATEGORY_LABELS[category]}
    </span>
  );
}
